import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';

import type { SearchSecretAttributeType } from '../index';
import { clearActiveSecretAttributeFilters, toggleActiveSecretAttributeFilter } from '../services/actions';
import { selectActiveSecretsAttributesFilters } from '../services/selectors';

export const useSecretsAttributesFilter = () => {
    const filter = useAppSelector(selectActiveSecretsAttributesFilters);

    const dispatch = useDispatch();

    const toggleFilter = (value: string, label: string, type: SearchSecretAttributeType, active: boolean) => {
        dispatch(toggleActiveSecretAttributeFilter(value, label, type, active));
    };

    const clearFilter = () => {
        dispatch(clearActiveSecretAttributeFilters());
    };

    return {
        filter,
        toggleFilter,
        clearFilter,
    };
};
